<div>

<ppl-accordion [title]="'File Upload'" [isOpen]="true" *authorize="[pageId, tabId, 'FileUpload', 'section']">
    <div class="document-history-wrapper">
      @if(isEnrollmentEntry && isHistoryRole){
      <div class="document-history-action">
        <ppl-button ariaLabel="Document History" label="Document History" icon="fa fa-history" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="openDocumentHistory()"></ppl-button>
      </div>
      }
      <ppl-file-upload [filedInfo]="filedInfo" [sectionData]="steps" [entry]="entry" [pageId]="pageId" [tabId]="tabId" (filesUpdated)="filesUpdated()" [readonly]="readonly"></ppl-file-upload>
    </div>
  </ppl-accordion>

  <div class="filter-panel">
    <ng-template #documentHistoryDialog let-cancel="cancel">
      <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false"
        [data]="documentHistoryData" [disableSelection]="true" [cols]="documentHistoryCols"
        [gridTitle]="false" [pagination]="false">
      </ppl-list-table>
    </ng-template>
  </div>
</div>